import { createUseStyles } from 'react-jss';
import classnames from 'classnames';
import { Theme } from '@app/theme';
import { Link } from './Link';
import { useTranslation } from 'react-i18next';
import { ConsentName, useGetConsentUrl } from '@app/api';

const useStyles = createUseStyles((theme: Theme) => ({
  container: {
    width: '100%',
    padding: [theme.marginBase * 5, theme.marginBase * 3],
    [theme.media.mobile]: {
      background: theme.colors.white,
      padding: [theme.marginBase * 4, theme.marginBase * 2],
    },
  },
  wrapper: {
    display: 'flex',
    maxWidth: theme.maxContentWidth.screen,
    margin: '0 auto',
    gap: theme.marginBase * 2,
    justifyContent: 'center',
    flexWrap: 'wrap',
    paddingTop: theme.marginBase * 4,
    borderTop: `1px solid ${theme.colors.inkTertiary}`,
    alignItems: 'center',
  },
  label: {
    ...theme.fonts.label,
    color: theme.colors.inkSecondary,
  },
  caption: {
    ...theme.fonts.caption,
    color: theme.colors.inkSecondary,
  },
}));

export const FooterStudy = () => {
  const classes = useStyles();
  const { t } = useTranslation('common');
  const getConsentUrl = useGetConsentUrl();

  return (
    <div className={classes.container}>
      <div className={classes.wrapper}>
        <p className={classes.caption}>© Tandemz 2019</p>
        <Link
          className={classes.label}
          href={getConsentUrl(ConsentName.PARTICIPANT_TERMS)}
          target="_blank"
        >
          {t('footer.terms')}
        </Link>
        <Link
          className={classes.label}
          href={getConsentUrl(ConsentName.PARTICIPANT_PRIVACY)}
          target="_blank"
        >
          {t('footer.privacy')}
        </Link>
        <Link
          className={classes.label}
          href={getConsentUrl(ConsentName.PARTICIPANT_RULES)}
          target="_blank"
        >
          {t('footer.participationRules')}
        </Link>
        <Link className={classnames(classes.label, 'cky-banner-element')}>
          {t('footer.cookies')}
        </Link>
      </div>
    </div>
  );
};
